import { createContext } from 'react';
const PersonalizationEditorContext = /*#__PURE__*/createContext({});
export default PersonalizationEditorContext;